import { useMemo } from 'react';
import { useTheme } from 'tamagui';

export const useTabBarStyle = () => {
  const { background, borderColor } = useTheme();

  return useMemo(
    () => ({
      backgroundColor: background.get(),
      borderTopWidth: 2,
      borderTopColor: borderColor.get(),
      elevation: 0
    }),
    [background, borderColor]
  );
};
